/** Aviso al programar visita a propiedad con llaves: ubicación actual + cita anterior + próximas pendientes. */
export default function ModalAvisoLlavesCitas({
  isOpen,
  contexto,
  onClose,
  theme,
  zIndex = 1600,
}) {
  if (!isOpen || !contexto) return null;
  const c = theme?.colors || {};
  const isDark = theme?.name === "dark";
  const prop = contexto.propiedad || {};
  const ubic = contexto.ubicacion_llaves || {
    llaves_ubicacion: prop.llaves_ubicacion,
    llaves_con_quien: prop.llaves_con_quien,
    llaves_desde: prop.llaves_desde,
    llaves_telefono: prop.llaves_telefono,
  };
  const ant = contexto.ultima_anterior;
  const prox = Array.isArray(contexto.proximas_pendientes) ? contexto.proximas_pendientes : [];

  const fmt = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleString("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return String(iso);
    }
  };

  const card = {
    padding: "12px 14px",
    borderRadius: 10,
    border: `1px solid ${c.border || "#d4d4d8"}`,
    background: isDark ? (c.bgInput || "#1e1e24") : "#f8f8f4",
    marginBottom: 8,
  };

  const ubicacion = ubic?.llaves_ubicacion || "oficina";
  const fuera =
    ubicacion === "externo" || ubicacion === "pendiente_aceptacion";
  const ubicCard = {
    ...card,
    border: fuera
      ? "1px solid rgba(239,68,68,0.35)"
      : `1px solid ${c.border || "#d4d4d8"}`,
    background: fuera
      ? (isDark ? "rgba(239,68,68,0.12)" : "rgba(254,226,226,0.7)")
      : card.background,
  };

  let ubicTitulo = "En oficina";
  let ubicDetalle = "Las llaves figuran en la oficina.";
  if (ubicacion === "pendiente_aceptacion") {
    ubicTitulo = "Pendiente de aceptación externa";
    ubicDetalle = [
      ubic?.llaves_con_quien,
      ubic?.llaves_telefono,
      ubic?.llaves_desde ? `desde ${fmt(ubic.llaves_desde)}` : null,
    ]
      .filter(Boolean)
      .join(" · ");
  } else if (ubicacion === "externo") {
    ubicTitulo = "Fuera con externo";
    ubicDetalle = [
      ubic?.llaves_con_quien,
      ubic?.llaves_telefono,
      ubic?.llaves_desde ? `desde ${fmt(ubic.llaves_desde)}` : null,
    ]
      .filter(Boolean)
      .join(" · ");
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(0,0,0,0.55)",
        fontFamily: "'DM Sans', sans-serif",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(460px, 96vw)",
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: 14,
          background: isDark ? c.bgCard : "#fff",
          border: `1px solid ${c.border || "#d4d4d8"}`,
          boxShadow: "0 16px 48px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "18px 20px 8px" }}>
          <div style={{ fontSize: 22, marginBottom: 6 }}>🔑</div>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: c.textPrimary }}>
            Propiedad con llaves
          </h3>
          <p style={{ margin: "8px 0 0", fontSize: 13, color: c.textSecondary, lineHeight: 1.45 }}>
            Ref. <strong style={{ color: c.textPrimary }}>{prop.referencia || "—"}</strong>
            {prop.titulo ? ` · ${prop.titulo}` : ""}
          </p>
          {(prop.num_llave || prop.recoger_llaves_en) && (
            <p style={{ margin: "6px 0 0", fontSize: 12, color: c.textMuted, lineHeight: 1.4 }}>
              {prop.num_llave ? `Nº llave: ${prop.num_llave}` : ""}
              {prop.num_llave && prop.recoger_llaves_en ? " · " : ""}
              {prop.recoger_llaves_en ? `Recoger en: ${prop.recoger_llaves_en}` : ""}
            </p>
          )}
        </div>

        <div style={{ padding: "8px 20px 4px" }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: c.textMuted,
              marginBottom: 8,
            }}
          >
            Dónde están ahora
          </div>
          <div style={ubicCard}>
            <div
              style={{
                fontSize: 14,
                fontWeight: 800,
                color:
                  ubicacion === "pendiente_aceptacion"
                    ? "#facc15"
                    : ubicacion === "externo"
                      ? "#4ade80"
                      : c.textPrimary,
              }}
            >
              {ubicTitulo}
            </div>
            {ubicDetalle && (
              <div style={{ fontSize: 12, color: c.textSecondary, marginTop: 4, lineHeight: 1.4 }}>
                {ubicDetalle}
              </div>
            )}
          </div>

          <div
            style={{
              fontSize: 11,
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: c.textMuted,
              margin: "14px 0 8px",
            }}
          >
            Última cita de compañero
          </div>
          {ant ? (
            <div style={card}>
              <div style={{ fontSize: 13, fontWeight: 700, color: c.textPrimary }}>
                {ant.agente_nombre || "Agente sin nombre"}
              </div>
              <div style={{ fontSize: 12, color: c.textSecondary, marginTop: 4 }}>
                {fmt(ant.fecha_inicio)}
                {ant.fecha_fin ? ` — ${fmt(ant.fecha_fin).split(", ").pop() || ""}` : ""}
              </div>
              <div style={{ fontSize: 12, color: c.textMuted, marginTop: 4 }}>
                {ant.cliente_display}
                {ant.estado ? ` · ${ant.estado}` : ""}
              </div>
            </div>
          ) : (
            <div style={{ ...card, color: c.textMuted, fontSize: 13 }}>
              No hay citas anteriores de compañeros con esta propiedad.
            </div>
          )}

          <div
            style={{
              fontSize: 11,
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: c.textMuted,
              margin: "14px 0 8px",
            }}
          >
            Citas pendientes de compañeros
          </div>
          {prox.length ? (
            prox.map((cita) => (
              <div key={cita.id} style={card}>
                <div style={{ fontSize: 13, fontWeight: 700, color: c.textPrimary }}>
                  {cita.agente_nombre || "Agente sin nombre"}
                </div>
                <div style={{ fontSize: 12, color: c.textSecondary, marginTop: 4 }}>
                  {fmt(cita.fecha_inicio)}
                </div>
                <div style={{ fontSize: 12, color: c.textMuted, marginTop: 4 }}>
                  {cita.cliente_display}
                  {cita.estado ? ` · ${cita.estado}` : ""}
                </div>
              </div>
            ))
          ) : (
            <div style={{ ...card, color: c.textMuted, fontSize: 13 }}>
              No hay citas pendientes de compañeros después de esta fecha.
            </div>
          )}
        </div>

        <div style={{ padding: "12px 20px 18px" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: 10,
              border: "none",
              background: "linear-gradient(135deg, #0369a1, #0ea5e9)",
              color: "#fff",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
